import {
  faLock as iconLock,
  faCheckCircle as iconCheck,
  faCalendarCheck as iconCalendarCheck,
  faEye as iconEye,
  faEyeSlash as iconEyeSlash,
} from '@fortawesome/free-solid-svg-icons';
import {
  EventDisplayDetails,
  EventDisplayInfo,
  FullCalendarEventInfo,
  Schedule,
  User,
} from "../../models";
import { getFilteredSchedules } from '../../data/api';

/**
 *
 * @param eventInfo
 * @param user
 * @returns EventDisplayDetails object
 * @use return styleing for
 * events in the calendar based on role and what state the event is in
 *
 */
export function getEventDisplay(eventInfo: EventDisplayInfo): EventDisplayDetails {
  const eventDisplayDetails: EventDisplayDetails = {
    backgroundColor: '#d2fcce',
    borderColor: eventInfo.published ? '#28ad00' : '#ff9b29',
    statusIcon: iconCheck,
    adminIcon: eventInfo.published ? iconEye : iconEyeSlash,
  };

  if (eventInfo.booked) {
    eventDisplayDetails.backgroundColor = '#eacccc';
    eventDisplayDetails.borderColor = eventInfo.published ? '#ff0000' : '#ff9b29';
    eventDisplayDetails.statusIcon = iconCalendarCheck;
  }

  if (eventInfo.locked) {
    eventDisplayDetails.backgroundColor = '#f5ff97';
    eventDisplayDetails.borderColor = eventInfo.published ? '#e5ff00' : '#ff9b29';
    eventDisplayDetails.statusIcon = iconLock;
  }

  return eventDisplayDetails;
}

/**
 *
 * @param start
 * @param end
 * @param user
 * @returns
 */
export async function getEventsFiltered(start: Date, end: Date, user: User): Promise<Array<FullCalendarEventInfo>> {
  const filteredEvents = async (): Promise<Array<FullCalendarEventInfo>> => {
    const result = await getFilteredSchedules(start, end, user?.token);

    return Promise.all(result.map(async (schedule: Schedule): Promise<FullCalendarEventInfo> => {

      const displayDetails = getEventDisplay({
        booked: schedule.booked,
        locked: schedule.locked,
        published: schedule.published
      });

      return {
        id: schedule.id,
        start: schedule.startDateTimeUTC,
        end: schedule.endDateTimeUTC,
        title: schedule.name,
        allDay: false,
        editable: false,
        duration: schedule.duration,
        backgroundColor: displayDetails.backgroundColor,
        borderColor: displayDetails.borderColor,
        extendedProps: {
          published: schedule.published,
          locked: schedule.locked,
          booked: schedule.booked,
          recurrenceId: schedule.recurrenceId || null,
          bookingInfo: schedule.bookingInfo || null
        }
      };
    }));
  };
  return filteredEvents();
}